import noop from 'lodash/noop';
import {createContext} from 'react';

import type {Props as DialogModalProps} from './sc-modal';

export type ModalContextType = {
    size: DialogModalProps['size'];
    open: DialogModalProps['open'];
    onClose: DialogModalProps['onClose'];
};

export const ModalContext = createContext<ModalContextType>({
    size: 'medium',
    open: false,
    onClose: noop,
});
